class ResourceManager {
    resources: any;
    constructor() {
        this.resources = {
            users: {},
            entities: {},
        };
    }

    get(type: string, id: string) {
        const resource = this.resources[type];
        return resource[id];
    }

    hydrate(resources: any) {
        if (!resources) return;
        this.hydrateUsers(resources.user);
        this.hydrateEntities(resources.entity);
    }

    hydrateUsers(users: Array<any>) {
        if (!Array.isArray(users)) return;
        const cacheUsers = this.resources.users;
        users.forEach((user) => {
            cacheUsers[user.userId] = user;
        });
    }

    hydrateEntities(entities: Array<any>) {
        if (!Array.isArray(entities)) return;
        const cacheEntities = this.resources.entities;
        entities.forEach((entity) => {
            cacheEntities[entity.entityId] = entity;
        });
    }
};

const cacheManager = new ResourceManager();
export default cacheManager;